<div class="hero" [class.compact-hero]="buyHidden && !compareVisible && !levelsVisible">
  <img class="hero-image" [class.level__1]="level === productLevel.Level1"
    [class.level__2]="level === productLevel.Level2" [class.level__3]="level === productLevel.Level3"
    [class.smart-tag]="level === productLevel.SmartTag" [src]="bannerImage.planBannerImageSrc"
    [style.object-position]="bannerImage.objectPosition" alt="Product banner image">

  <div class="hero-overlay"></div>

  <ng-container *appFeatureFlag="'productPageBannerDisplayHeroBadge'">
    <img class="hero-badge" *ngIf="!!badgeUri" [src]="badgeUri" alt="hero-badge" />
  </ng-container>

  <div class="hero-content d-flex">
    <div class="container d-flex flex-row">
      <div class="hero-content-text">
        <div class="col d-flex flex-row ms-0 ps-0 mt-lg-4 mt-md-3 mt-sm-1 pe-0 pt-1 mb-0 mb-sm-3">
          <ng-container *appFeatureFlag="'productPageBannerDisplayPawIcon'">
            <img class="me-lg-1 me-md-1 me-sm-0 paw-image" *ngIf="level === productLevel.Level1 && levelsVisible"
              src="/assets/images/identibase/paw.svg" />
          </ng-container>
          <span *ngIf="levelsVisible" class="me-3 level" [class.active-level]="level === productLevel.Level1">
            <a [routerLink]="plan1Route">Level 1</a>
          </span>
          <ng-container *appFeatureFlag="'productPageBannerDisplayPawIcon'">
            <img class="me-lg-1 me-md-1 me-sm-0 paw-image" *ngIf="level === productLevel.Level2 && levelsVisible"
              src="/assets/images/identibase/paw.svg" />
          </ng-container>
          <span *ngIf="levelsVisible" class="me-3 level" [class.active-level]="level === productLevel.Level2">
            <a [routerLink]="plan2Route">Level 2</a>
          </span>
        </div>
        <div class="row h-75">
          <div class="col hero-content-text-title pt-2 pt-xl-2">
            <div>
              <h1 class="mt-lg-3 mt-md-3 mt-sm-2">{{ title }}</h1>
              <h6 class="mt-lg-3 mt-md-3 mt-sm-2" [innerHTML]="subtitle">
              </h6>
              <h5 *ngIf="!!secondarySubtitle" class="mt-lg-3 mt-md-3 mt-sm-2" [innerHTML]="secondarySubtitle">
              </h5>
            </div>
            <div class="row">
              <div *ngIf="!buyHidden" class="col-6">
                <button (click)="buy()" type="button" class="btn blue-button" [disabled]="disabled">
                  {{ buyButtonText ? buyButtonText : 'Buy now' }}
                </button>
              </div>
              <div class="col-6 pt-lg-2 pt-md-2 pt-sm-1 px-1 px-xl-2">
                <a *ngIf="compareVisible" [routerLink]="[]" (click)="compare()" class="compare-link">
                  Compare our plans
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>